import { useTranslation } from "react-i18next";
import { useGlobal } from "context/GlobalContext";
import { useEffect, useRef, useState } from "react";
import SvgReload from "../svg/SvgReload";
import { useLocation } from "react-router-dom";
import SolarIcon from 'components/icons/SolarIcon';

const allowSearch = ['/users', '/leads', '/clients', '/customers', '/objects', '/products', '/services', '/sets', '/vendors', '/4team/warehouse'];

const isSearchAllowed = (pathname) =>
    allowSearch.includes(pathname) || pathname?.startsWith('/warehouse') || pathname?.startsWith('/tools');

const SearchBar = () => {
    const { t } = useTranslation();
    const { g } = useGlobal();
    const refMobInputSearch = useRef(null);
    const location = useLocation();
    const [mobSearchOpen, setMobSearchOpen] = useState(false);
    const [draft, setDraft] = useState('');

    const searchAllowed = isSearchAllowed(location.pathname);
    const currentSearch = g.search?.[location.pathname] ?? '';

    useEffect(() => {
        setDraft(currentSearch);
    }, [location.pathname, currentSearch]);

    const handleReset = () => {
        setDraft('');
        g.setSearch((prev) => ({
            ...prev,
            [location.pathname]: null
        }));
        g.setTarget(!g.target);
    };

    const handleSubmitSearch = (e, fromMobile = false) => {
        e.preventDefault();
        const trimmed = draft.trim();
        setDraft(trimmed);
        g.setSearch((prev) => ({
            ...prev,
            [location.pathname]: trimmed
        }));
        if (fromMobile) setMobSearchOpen(false);
    };

    useEffect(() => {
        setMobSearchOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        if (mobSearchOpen) {
            refMobInputSearch.current?.focus();
        }
    }, [mobSearchOpen]);

    if (!searchAllowed) return null;

    return (
        <>
            <div className="pc-h-item d-flex align-items-center">
                <form
                    className="form-search d-none d-sm-inline-flex"
                    onSubmit={(e) => handleSubmitSearch(e)}
                >
                    <SolarIcon name="search" style={{
                            lineHeight: '35px',
                            fontSize: '16px'
                        }} />
                    <input
                        type="text"
                        value={draft}
                        onChange={(e) => setDraft(e.target.value)}
                        className="form-control"
                        placeholder={t('SearchBar.palceHolder')}
                    />
                </form>

                <div className="d-sm-none px-0">
                    <span
                        style={{width: '30px', height: '30px'}}
                        className={`pc-head-link ms-0 px-0 cursor-pointer${mobSearchOpen ? ' active' : ''}${currentSearch ? ' mob-search-has-value' : ''}`}
                        onClick={() => setMobSearchOpen((prev) => !prev)}
                        aria-label={t('SearchBar.palceHolder')}
                    >
                        <SolarIcon name="search" />
                        
                    </span>
                </div>

                <div className="ms-1">
                    <span style={{width: '30px', height: '30px'}}
                        className="avtar cursor-pointer btn-sm btn-link-secondary px-0"
                        onClick={() => handleReset()}
                    >
                        <SvgReload />
                    </span>
                </div>
            </div>

            {mobSearchOpen && (
                <div className="mob-search-panel">
                    <form
                        className="mob-search-form"
                        onSubmit={(e) => handleSubmitSearch(e, true)}
                    >
                        <SolarIcon name="search" className="mob-search-form-icon" />
                        <input
                            type="text"
                            ref={refMobInputSearch}
                            value={draft}
                            onChange={(e) => setDraft(e.target.value)}
                            className="form-control"
                            placeholder={t('SearchBar.palceHolder')}
                        />
                        <button
                            type="button"
                            className="mob-search-close btn btn-link-secondary"
                            onClick={() => setMobSearchOpen(false)}
                            aria-label="Close"
                        >
                            <SolarIcon name="x-lg" />
                        </button>
                    </form>
                </div>
            )}
        </>
    );
};

export default SearchBar;
